/**
 * promo-popup.js — popup banner khuyến mãi (in ở footer, mọi trang). File này chỉ quyết định KHI NÀO mở;
 * mở / đóng đi qua window.WBModal (js/modal.js: khoá cuộn, giữ focus, Esc, bấm nền, nút [data-modal-close]).
 *
 * Markup: .modal[data-promo-popup][data-promo-popup-id="slug chương trình"][data-promo-popup-cooldown="phút"]
 *         để sẵn thuộc tính hidden — như cổng tuổi, không chớp lên trước khi script kịp đọc localStorage.
 *
 * Luật hiển thị:
 *   1. Chỉ SAU cổng tuổi (mục 13). Khách chưa xác nhận 18+ thì chờ sự kiện agegate:confirm (js/age-gate.js)
 *      rồi mới mở: không bao giờ hai hộp thoại chồng nhau, và chưa xác nhận tuổi thì chưa thấy quảng cáo rượu.
 *   2. Hiện một lần rồi thôi, 15 phút sau mới được hiện lại. Mốc thời gian (localStorage wb_promo_popup_at)
 *      ghi lúc popup hiện VÀ lúc khách đóng ⇒ 15 phút tính từ khi popup ẩn; chuyển trang / F5 / mở tab mới
 *      trong khoảng đó đều không hiện. Quá 15 phút thì lần tải trang kế tiếp mới hiện — không tự bật giữa
 *      chừng khi khách đang đọc.
 *   3. Không mở ở giỏ hàng, thanh toán, đặt hàng xong, tra cứu đơn: chen quảng cáo vào lúc khách đang trả
 *      tiền chỉ làm rơi đơn.
 *   4. Đang có modal khác mở (vd contact.html#contact-success) thì bỏ lượt này, không ghi mốc.
 *   5. Trình duyệt chặn localStorage thì KHÔNG mở — không nhớ được mốc thì popup sẽ bật lên ở mọi trang.
 *   6. Tab đang nằm nền (mở bằng Ctrl + click) thì đợi khách chuyển sang tab đó mới mở, và kiểm tra lại mốc
 *      ngay lúc mở — mở 5 tab một lúc chỉ tab khách xem đầu tiên có popup.
 *
 * Đo lường: view_promotion lúc hiện (gọi WBTrack), select_promotion / coupon_copy qua data-track trong
 * markup, promo_popup_close lúc đóng.
 *
 * Xem thử không phải chờ 15 phút: thêm ?promo-popup vào URL (vẫn đi sau cổng tuổi).
 *
 * WP: giữ nguyên file; footer.php chỉ in popup khi Theme Options popup_enabled bật và chương trình còn hạn
 * (html/WORDPRESS.md).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var KEY = 'wb_promo_popup_at';
    var AGE_KEY = 'wb_age_ok'; // js/age-gate.js
    var DELAY = 1200; // trang đã qua cổng tuổi: để khách thấy trang trước, rồi mới hiện popup
    var AFTER_GATE = 400; // vừa bấm "Tôi đủ 18 tuổi": chờ cổng tuổi mờ hẳn (220ms) rồi mới mở
    var SKIP = ['woocommerce-cart', 'woocommerce-checkout', 'woocommerce-order-tracking'];

    var popup = document.querySelector('[data-promo-popup]');
    if (!popup) return;

    var minutes = Number(popup.getAttribute('data-promo-popup-cooldown')) || 15;
    var cooldown = minutes * 60 * 1000;
    var id = popup.getAttribute('data-promo-popup-id') || '';
    var force = /[?&]promo-popup(=|&|$)/.test(window.location.search);

    function read(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function stamp() {
        try {
            window.localStorage.setItem(KEY, String(Date.now()));
            return true;
        } catch (e) {
            return false;
        }
    }

    function track(name) {
        if (window.WBTrack) window.WBTrack(name, { label: id, creative_slot: 'popup' });
    }

    function skippedPage() {
        return SKIP.some(function (cls) {
            return document.body.classList.contains(cls);
        });
    }

    function due() {
        if (force) return true;
        var last = Number(read(KEY)) || 0;
        // Mốc nằm ở tương lai (đồng hồ máy bị chỉnh lùi) thì coi như đã hết hạn chờ
        return Date.now() - last >= cooldown || last > Date.now();
    }

    function otherModalOpen() {
        return !!document.querySelector('.modal.is-open, .modal:target:not(.is-dismissed)');
    }

    function whenVisible(fn) {
        if (!document.hidden) {
            fn();
            return;
        }
        document.addEventListener('visibilitychange', function onVisible() {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVisible);
            fn();
        });
    }

    function open() {
        // Kiểm tra lại ngay lúc mở: tab khác có thể vừa hiện popup trong lúc tab này chờ
        if (!due() || otherModalOpen() || !window.WBModal) return;
        if (!stamp()) return; // luật 5
        popup.hidden = false;
        // Đợi một khung hình để transition opacity chạy được sau khi bỏ hidden (như js/age-gate.js)
        window.requestAnimationFrame(function () {
            window.WBModal.open(popup);
            track('view_promotion');
        });
    }

    function schedule(delay) {
        window.setTimeout(function () {
            whenVisible(open);
        }, delay);
    }

    popup.addEventListener('modal:close', function (event) {
        if (event.target !== popup) return;
        stamp(); // 15 phút tính từ lúc popup ẩn (luật 2)
        track('promo_popup_close');
        window.setTimeout(function () {
            popup.hidden = true;
        }, 220);
    });

    if (skippedPage() || !due()) return;

    // Ảnh để loading="lazy" để 15 phút chờ không tải ảnh ở mọi trang; nằm trong [hidden] thì lazy không bao
    // giờ tải — sắp mở thì chuyển sang tải ngay, kịp xong trong lúc chờ DELAY / khách bấm cổng tuổi.
    var image = popup.querySelector('img[loading="lazy"]');
    if (image) image.loading = 'eager';

    if (read(AGE_KEY) === '1') {
        schedule(DELAY);
    } else {
        document.addEventListener('agegate:confirm', function () {
            schedule(AFTER_GATE);
        });
    }
})();
